<template>
  <div class="pdf-box">
    <pdf
      class="pdf-container"
      v-for="i in numPages"
      :key="i"
      :page="i"
      :src="pdf_url"
    ></pdf>
    <!-- <p class="arrow">
      <span @click="changePdfPage(0)" class="turn turn-prev" :class="{gray: currentPage==1}">上一页</span>
      {{currentPage}} / {{pageCount}}
      <span
        @click="changePdfPage(1)"
        class="turn turn-next"
        :class="{gray: currentPage==pageCount}"
      >下一页</span>
    </p> -->
  </div>
</template>
<script>
import http from "../request/http";

import pdf from "vue-pdf";
export default {
  name: "pdf_template",
  data() {
    return {
      pdf_src: "",
      currentPage: 0, // pdf文件页码
      pageCount: 0, // pdf文件总页数
      fileType: "pdf",
      type: 0,
      pdf_url: "",
      numPages:1
    };
  },
  components: {
    pdf,
  },
  created() {
    // 1 医生注册协议 2 法律声明与隐私协议 3用户注册协议 4收入结算 5开方说明
    if (this.$route.query.pdf) {
      this.pdf_src = this.$route.query.pdf;
      switch (this.pdf_src) {
        case "user_register_protocol.pdf":
          this.type = 3;
          break;
        case "legal_notice.pdf":
        case "layer.pdf":
          this.type = 2;
          break;
        case "doctor_accounts.pdf":
          this.type = 4;
          break;
        case "doctor_register.pdf":
          this.type = 1;
          break;
        case "Explanation_of_prescription.pdf":
          this.type = 5;
          break;
        default:
          this.type = 0;
      }
    }
  },
  mounted(){
    this.getPdf();
  },
  methods: {
    pdfTask(pdfUrl) {
      let self = this;
      let loadingTask = pdf.createLoadingTask(pdfUrl);
      loadingTask.promise.then(pdf => {
        self.pdf_url = loadingTask;
        self.numPages = pdf.numPages;
      }).catch(err => {
        console.log(err,'33')
      });
    },
    getPdf() {
      let url = '';
      http.post("/api/wap/public/document", { type: this.type }).then((res) => {
        if (res.errno == 0) {
          switch (this.type){
            case 4:
              url = '/static/doctor_accounts.html';
              break;
            case 5:
              url = '/static/Explanation_of_prescription.html';
              break;
            case 1:
              url = '/static/doctor_register.html';
              break;
            case 2:
              url = '/static/layer.html';
              break;
            case 3:
              url = '/static/user_register_protocol.html';
              break;
            default:
              url = '';
          }
          location.replace(url)
        }
      });
    },
    changePdfPage(val) {
      if (val === 0 && this.currentPage > 1) {
        this.currentPage--;
      }
      if (val === 1 && this.currentPage < this.pageCount) {
        this.currentPage++;
      }
    },

    // pdf加载时
    loadPdfHandler(e) {
      this.currentPage = 1; // 加载的时候先加载第一页
    },
  },
};
</script>
<style scoped>
.pdf-box {
  width: 100vw;
  height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
}
.arrow {
  width: 100vw;
  height: 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1rem;
  box-sizing: border-box;
  font-size: 0.8rem;
  margin-top: 0.5rem;
}
.turn {
  display: inline-block;
  width: 5rem;
  height: 2rem;
  line-height: 2rem;
  color: #fff;
  border-radius: 1rem;
  background: rgba(24, 144, 255, 1);
  font-size: 0.8rem;
  text-align: center;
}
.pdf-container {
  width: 100vw;
  height: 100vh;
  padding: 0 !important;
  overflow: auto;
}
.gray {
  background-color: rgba(255, 255, 255, 1);
  color: rgba(0, 0, 0, 0.65);
  border: 0.05rem solid rgba(232, 232, 232, 1);
}
/* .turn-next{
    margin-left: 0.5rem;
}
.turn-prev{
    margin-right: 0.5rem;
} */
#iframebox {
  width: 100vw;
  min-height: 100vh;
  height: auto;
}
</style>


// WEBPACK FOOTER //
// src/pages/pdf.vue